<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <figure>
            <img src="/img/logo.png" alt="Omni-note Logo" style="height: 100px;">
          </figure>
          <p>{{ $t('footer.description') }}</p>
        </div>
        
        <div class="footer-section">
          <h4>Omni-note</h4>
          <ul class="footer-links">
            <a href="https://github.com/turingevo">github.com/turingevo</a>
            <a href="http://www.turingevo.com">turingevo.com</a>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>{{ $t('footer.friendlyLinks') }}</h4>
          <ul class="footer-links">
            <li><a href="https://www.arm.com/" target="_blank" rel="noopener">ARM</a></li>
            <li><a href="https://www.intel.com/" target="_blank" rel="noopener">Intel</a></li>
            <li><a href="https://www.lenovo.com/" target="_blank" rel="noopener">Lenovo</a></li>
            <li><a href="https://www.qualcomm.com/" target="_blank" rel="noopener">Qualcomm</a></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>{{ $t('footer.contactUs') }}</h4>
          <div>
            <img src="/img/WeChatOfficialAccount.jpg" alt="WeChat Official Account QR Code" style="height: 100px;">
            <p>{{ $t('footer.officialAccount') }}</p>
          </div>
          <p>{{ $t('footer.questions') }} <a href="mailto:wmx@turingevo.com" style="color: #ccc;">wmx@turingevo.com</a></p>
        </div>
      </div>
      
      <div class="copyright">
        <p>Copyright © 2025 深圳市进化图灵智能科技有限公司 turingevo.com</p>
        <p>备案号：<a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备2024240369号</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  background-color: #333;
  color: white;
  padding: 60px 0 30px;
  margin-top: 100px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
}

.footer-section {
  display: flex;
  flex-direction: column;
}

.footer-section h4 {
  margin-bottom: 20px;
  font-size: 1.2rem;
  color: #fff;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 10px;
  display: block;
}

.footer-links a {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s ease;
  display: block;
}

.footer-links a:hover {
  color: #fff;
}

.social-links {
  display: flex;
  gap: 15px;
  margin-top: 20px;
}

.social-links a {
  color: white;
  font-size: 20px;
  transition: transform 0.3s ease;
}

.social-links a:hover {
  transform: translateY(-3px);
}

.copyright {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid #555;
  color: #aaa;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer {
    padding: 40px 0 20px;
  }
  
  .footer-content {
    gap: 30px;
  }
}
</style>
